import { useEffect, useState } from "react"
import { ListLoaderWrapper } from "../../../../../features/data-types"
import { TableName } from "../../../../../tables"
import { CustomerTypeList } from "./customerTypeList"
import { useCustomerTypeLoaders } from "../../../loaders/customerTypeLoaders"
import { PanelLoader } from "../../../../../features/ui"
import { BookmarkButton } from "../../../../../features/bookmarks"
import { RoutePath } from "../../../../../features/routes"

const Loader = () => {
    const [ready, setReady] = useState(false)

    const customerTypeLoaders = useCustomerTypeLoaders()
    // Se lee del state (no de la respuesta del fetch) para incluir listas recién creadas
    // que la query a DynamoDB todavía no devuelve por consistencia eventual
    const customerTypes = customerTypeLoaders().findAllCustomerTypes(true)

    useEffect(() => {
        customerTypeLoaders().loadAllCustomerTypes(true).then(() => setReady(true))
    }, [])

    return (
        <PanelLoader
            title="Listas de Precios"
            ready={ready}
            titleRight={<BookmarkButton routePath={RoutePath.CUSTOMER_TYPES} />}
        >
            <CustomerTypeList customerTypes={customerTypes} />
        </PanelLoader>
    )
}

export const CustomerTypeListLoader = () => (
    <ListLoaderWrapper table={TableName.CUSTOMER_TYPES}>
        <Loader />
    </ListLoaderWrapper>
)
